<template>
  <div>
    <b-container>
      <Oom
          :config="config"
          :tm_params="tm_params"
          :data="data"
          :id="id"
      />
    </b-container>
    <!-- <div class="seeMore" v-on:click="isHidden = !isHidden">
      <template v-if="!isHidden">
        <div class="SeeMoreText">
          See More
        </div>
      </template>
      <template v-else>
        <div class="SeeMoreText">
          See Less
        </div>
      </template>
    </div> -->
    <div class="middleAd-above-vid">
        <!-- <span class="advertCen">ADVERT</span>
        <Ads class='mobHide' :page="'home'" :adNum="'third'" :mob='false' :side='false'/>   -->
    </div>
  </div>
</template>

<script>
import { Oom } from "@ocs-software/vue-ocs";
export default {
  name: "statsTable",
  props: ["id", "stat", "data", "config"],
  components: {
    Oom
  },
  data() {
    return {
      noData: "noData",
      flag: "flag",
      cell: "cell",
      fields: "fields",
      name: "name",
      isHidden: false
    };
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    },
  },
};
</script>

<style scoped>
::v-deep .container {
    padding-left: 0;
    padding-right: 0;
}
::v-deep tr:nth-child(odd) {
    background-color: #fff;
}
::v-deep .sponindlogo {
  width: 45px;
}
::v-deep th.cell.fields:nth-child(1) {
  text-align: left;
}
::v-deep td:nth-child(1) {
  text-align: left;
  color: #707070;
}
::v-deep th.cell.fields:nth-child(2) {
  text-align: left;
}
::v-deep td.playerNameNon{
  text-align: left;
  color: #76c3bd !important;
  font-weight: 500;
}
::v-deep .table thead th {
    vertical-align: bottom;
    border-bottom: 0px solid #dee2e6!important;
    border-top: 0px solid #dee2e6!important;
}
::v-deep .fields {
  background-color: #76c3bd!important;
  font-size: 14px;
}
::v-deep .cell{
    text-align: center;
    font-size: 14px;
}
td.cut {
  color: #ffffff;
  text-align: left;
}
::v-deep tr.cutBK {
  background-color: #000!important;
  color: #ffffff;
}
td.posColor {
  color: #000;
  font-weight: bold;
}
.TextCen {
  text-align: center;
}
span.advertCen {
  text-align: center;
  display: block;
  margin-top: 50px;
  font-weight: bold;
  font-size: 20pt;
}
.seeMore {
  background: #000;
  text-align: center;
  margin: auto;
  padding: 8px;
  width: 200px;
  margin-top: 30px;
  height: 30px;
}
.seeMore:hover {
  background: #2c2c2c;
  text-align: center;
  margin: auto;
  padding: 8px;
  width: 200px;
  margin-top: 30px;
}
.SeeMoreText {
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  text-transform: capitalize;
  line-height: 13px;
}
a.moreInfo {
  color: #6C6C6C!important;
  font-weight: bold;
  font-size: 13px;
}
a.moreInfo:hover {
  color: #000!important;
  font-weight: bold;
  font-size: 13px;
  text-decoration: none
}
span.rightArrow {
  margin-left: 10px;
}
a.OOMstatsColour {
  color: #6C6C6C!important;
  font-weight: bold;
  font-size: 13px;
}
a.OOMstatsColour:hover {
  color: #000!important;
  text-decoration: none;
  font-weight: bold;
  font-size: 13px;
}
.event-lb-sponsor-logo {
  /* width: 15px; */
  width: 31px;
  position: relative;
  left: 15px;
}
table > tbody > tr > td {
  padding: 0.75rem;
  vertical-align: top;
  line-height: 1.42857143;
  border-right: none !important;
  cursor: pointer;
  font-size: 13px;
  color: #6C6C6C;
}
table > thead > tr > th {
  background-color: #000;
  color: #fff;
  position: sticky;
  position: -webkit-sticky;
  color: #ffffff !important;
  padding: 0.75rem;
  font-size: 13px;
  font-weight: 500;
}
table {
  width: 100%;
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}

tr {
  /* background-color: rgba(0, 0, 0, 0.05); */
  border-bottom: 1px solid #ebebeb;
}
@media only screen and (max-width: 990px) {
  .seeMore {
    background: #000;
    text-align: center;
    margin: auto;
    padding: 8px;
    width: 100%;
    margin-top: 30px;
  }
}
@media only screen and (max-width: 768px) {
  .mobInfo {
    width: 80%;
    text-align: left;
  }
}
@media only screen and (max-width: 480px) {
  td.mobNo {
    display: none;
  }
  th.mobNo {
    display: none;
  }
  .tCont {
    padding: 70px 20px 20px;
    background-color: white;
    border-radius: 10px;
    margin-top: 0px;
  }
}
</style>
